export enum AlertMessageType {
    success = 'alert-success',
    info = 'alert-info',
    warning = 'alert-warning',
    danger = 'alert-danger',
    primary = 'alert-primary',
    secondary = 'alert-secondary',
    dark = 'alert-dark',
    light = 'alert-light'
}

export interface AlertMessage {
    text: String;
    type: AlertMessageType;
}
